var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBooks = function SvgBooks(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.91677 2.36133H3.75011C3.36658 2.36133 3.05566 2.67224 3.05566 3.05577V16.9447C3.05566 17.3282 3.36658 17.6391 3.75011 17.6391H7.91677C8.30031 17.6391 8.61122 17.3282 8.61122 16.9447V3.05577C8.61122 2.67224 8.30031 2.36133 7.91677 2.36133Z",
    stroke: "#919191",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7838 16.7503L13.7204 17.6184C13.6308 17.6374 13.5384 17.6386 13.4484 17.6218C13.3584 17.605 13.2726 17.5705 13.1959 17.5204C13.1193 17.4703 13.0533 17.4056 13.0018 17.3299C12.9503 17.2542 12.9142 17.169 12.8957 17.0793L10.0155 3.38488C9.97679 3.20398 10.0112 3.0151 10.1112 2.85946C10.2112 2.70382 10.3687 2.59407 10.5494 2.55416L14.6128 1.6861C14.7023 1.66705 14.7948 1.66589 14.8848 1.68271C14.9748 1.69952 15.0606 1.73397 15.1372 1.78407C15.2139 1.83417 15.2799 1.89894 15.3314 1.97464C15.3829 2.05034 15.4189 2.13548 15.4374 2.22516L18.3176 15.9196C18.3564 16.1005 18.322 16.2894 18.222 16.445C18.1219 16.6007 17.9644 16.7104 17.7838 16.7503Z",
    stroke: "#919191",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.05566 5.13867H8.61122",
    stroke: "#919191",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.05566 14.8613H8.61122",
    stroke: "#919191",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4482 5.4413L15.8692 4.27637",
    stroke: "#919191",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0234 8.18056L16.4453 7.01562",
    stroke: "#919191",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4644 15.0302L17.8854 13.8652",
    stroke: "#919191",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgBooks;